import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav_header8",
  "use": "icon-nav_header8-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" id=\"icon-nav_header8\">\r\n  <path d=\"M127.905275,88 L216,172.270677 L178.299247,172.270677 L178.299247,232 L77.3218516,232 L77.1324005,172.270677 L40,172.270677 L127.905275,88 Z M224,40 L224,72 L32,72 L32,40 L224,40 Z\" transform=\"matrix(1 0 0 -1 0 272)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol